import React, { FC, useCallback } from 'react'
import { useHistory, useRouteMatch } from 'react-router-dom'

import { Button, Grid, Typography } from '@mui/material'
import { Theme } from '@mui/material/styles'
import { makeStyles } from '@mui/styles'

import { RootPage } from '../menuTabList'

interface MenuTabProps {
  item: RootPage
}

const useStyles = (active: boolean) =>
  makeStyles((theme: Theme) => ({
    tab: {
      minWidth: '100%',
      height: 40,
      display: 'flex',
      justifyContent: 'flex-start',
      margin: '0',
      paddingLeft: '56px',
      color: active ? theme.palette.primary.light : '#9b9c9f',
      backgroundColor: 'inherit',
      '&:hover': {
        background: 'transparent',
        color: 'white',
      },
    },

    titleTab: {
      fontSize: 12,
      textTransform: 'none',
      marginLeft: 12,
    },
  }))()

export const MenuSubTab: FC<MenuTabProps> = ({ item }) => {
  const { name, icon, path } = item
  const match = useRouteMatch({ path: path || 'unknownPath', exact: true })
  const { tab, titleTab } = useStyles(!!match)
  const history = useHistory()

  const redirect = useCallback(() => {
    if (path) {
      const table = ['/settings/general', '/settings/settings', '/settings/assets']
      const url = typeof path === 'string' ? path : path[0]
      history.push(`${table.includes(url) ? `${url}?page=1` : url}`)
    }
  }, [history, path])

  return (
    <Grid item container direction={'column'}>
      <Button className={`${tab}`} onClick={redirect}>
        <span className="material-icons">{icon}</span>
        <Typography variant={'body1'} className={titleTab}>
          {name}
        </Typography>
      </Button>
    </Grid>
  )
}
